import webSDKCore from '@tencent/ti18n-websdkcore';
import { initReactI18next } from '@tencent/ti18n-react-sdk';
import { changeLang } from './libs/tools';

const getInitialLanguage = () => {
  const storedLanguage = window.localStorage.getItem('ti18nLng');
  if (storedLanguage === 'en' || storedLanguage === 'zh-CN') return storedLanguage;
  return navigator.language.includes('zh') ? 'zh-CN' : 'en';
};

webSDKCore
  .use(initReactI18next)
  .init({
    appid: '60455', // 应用id，用于访问CDN线上配置的标识符
    ns: ['935'], // 命名空间
    defaultNS: ['935'], // 默认命名空间
    lng: 'zh-CN', // 默认中文
    fallbackLng: ['en'],
    preload: ['en'], // 预加载的语言
    partialBundledLanguages: true, // 部分从sdk传入，部分从connector获取
    debug: false, // 开启调试
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'ti18nLng',
      caches: ['localStorage'],
      use: ['localStorage', 'navigator', 'htmlTag'],
    },
    backend: {
      sVersion: 682,
      sCdnPrefix: 'https://static.imur.qq.com',
      isTestEnv: import.meta.env.MODE !== 'production',
    },
    cache: {
      isEnabled: true,
      expires: 86400, // 单位秒，一天
    },
  })
  .then(() => {
    changeLang(getInitialLanguage());
  });
